import { render, staticRenderFns } from "./CardWrongUsageRepeater.vue?vue&type=template&id=b9b58c48&scoped=true"
import script from "./CardWrongUsageRepeater.vue?vue&type=script&lang=js"
export * from "./CardWrongUsageRepeater.vue?vue&type=script&lang=js"
import style0 from "./CardWrongUsageRepeater.vue?vue&type=style&index=0&id=b9b58c48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9b58c48",
  null
  
)

export default component.exports